'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import classNames from 'classnames';
import { OLAF } from 'HubStyleTokens/colors';
import colr from './vendor/colr';
import Panel from './Panel';
import { jsx as _jsx } from "react/jsx-runtime";
const computeHue = hex => {
  const hsv = colr.fromHex(hex).toHsvObject();
  if (hsv.s === 0) return null;
  return hsv.h;
};
const computeColorWithHue = (hex, hue) => {
  const hsv = colr.fromHex(hex).toHsvObject();
  if (hsv.s === 0) {
    return hex; // Hue has no effect on a color with no saturation.
  }
  return colr.fromHsvObject(Object.assign({}, hsv, {
    h: hue
  })).toHex();
};
export default class ColorPicker extends Component {
  static getDerivedStateFromProps(props, state) {
    const {
      prevHex
    } = state;
    const {
      color: hex
    } = props;
    if (prevHex !== hex) {
      const computedHue = computeHue(hex);
      if (computedHue != null) return {
        hue: computedHue,
        prevHex: hex
      };
      return {
        prevHex: hex
      };
    }
    return null;
  }
  constructor(props) {
    super(props);
    this.state = {
      hue: colr.fromHex(props.color).toHsvObject().h,
      prevHex: props.color
    };
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange({
    alpha,
    hex = this.props.color,
    hue
  }) {
    let color = hex;
    if (hue != null) {
      const currentHue = computeHue(hex);
      if (currentHue == null) {
        this.setState({
          hue
        });
      } else {
        color = computeColorWithHue(hex, hue);
      }
    }
    const changes = {};
    if (color != null) changes.color = color;
    if (alpha != null) changes.alpha = alpha;
    this.props.onChange(changes);
  }
  render() {
    const {
      alpha,
      alphaClassName,
      boardClassName,
      className,
      color: hex,
      colorsClassName,
      favorites,
      fieldsetSize,
      hexOnly,
      includeAlpha,
      onBlur,
      onFocus,
      ribbonClassName
    } = this.props;
    const {
      hue
    } = this.state;
    return /*#__PURE__*/_jsx(Panel, {
      "data-test-id": "colorpicker-advanced",
      alphaClassName: alphaClassName,
      boardClassName: boardClassName,
      colorsClassName: colorsClassName,
      className: classNames('private-react-colorpicker-popover--advanced', className),
      includeAlpha: includeAlpha,
      hexOnly: hexOnly,
      favorites: favorites,
      fieldsetSize: fieldsetSize,
      alpha: alpha,
      hex: hex,
      hue: hue,
      onChange: this.handleChange,
      onBlur: onBlur,
      onFocus: onFocus,
      mode: this.props.mode,
      ribbonClassName: ribbonClassName
    });
  }
}
ColorPicker.propTypes = {
  alpha: PropTypes.number,
  alphaClassName: PropTypes.string,
  boardClassName: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string.isRequired,
  colorsClassName: PropTypes.string,
  favorites: PropTypes.array,
  fieldsetSize: Panel.propTypes.fieldsetSize,
  hexOnly: PropTypes.bool,
  includeAlpha: PropTypes.bool,
  mode: PropTypes.oneOf(['RGB', 'HSL', 'HSB']),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  ribbonClassName: PropTypes.string
};
ColorPicker.defaultProps = {
  color: OLAF,
  includeAlpha: false,
  hexOnly: true,
  favorites: [],
  alpha: 100,
  onChange: () => null,
  onBlur: () => null,
  onFocus: () => null,
  style: {}
};